<template>
  <v-app id="inspire" class="fontLao">
    <div>
      <v-toolbar flat color="white">
        <v-toolbar-title>ສິນຄ້າຂາຍອອກ</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="ຊອກຫາ" single-line hide-details></v-text-field>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <v-btn slot="activator" color="primary" dark class="mb-2">ເພີ່ມ</v-btn>
          <v-card>
            <v-card-title>
            <span class="headline fontLao">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap class="fontLao">
                  <v-flex xs6 sm6 md6>
                    <v-text-field v-model="editedItem.order" type="text" label="Order#"></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm6 md6>
                    <v-text-field v-model="editedItem.orderdate" type="date" label="Order Date"></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm6 md6>
                    <v-text-field v-model="editedItem.invoiceno" type="text" label="Invoice No"></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm6 md6>
                    <v-text-field v-model="editedItem.invoicedate" type="date" label="Invoice Date"></v-text-field>
                  </v-flex>
                  <!-- <v-flex xs12 sm12 md12>
                    <v-select v-model="editedItem.cusid" :items="customer" item-value="id" item-text="name" label="Customer" ></v-select>
                </v-flex> -->

                <v-flex xs6 sm6 md6>
                      <v-autocomplete
                        :items="customer"
                        v-model="editedItem.cusid"
                        item-value="id"
                        item-text="name"
                        flat
                        hide-no-data
                        hide-details
                        label="Customer"
                        @change="initbranches()"
                      ></v-autocomplete>
                </v-flex>
                <v-flex xs6 sm6 md6>
                      <v-autocomplete
                        :items="branches"
                        v-model="editedItem.branch"
                        item-value="id"
                        item-text="branch"
                        flat
                        hide-no-data
                        hide-details
                        label="ສາຂາ"
                        @change="getbranches()"
                      ></v-autocomplete>
                </v-flex>


                  <!-- <v-flex xs12 sm12 md12>
                    <v-text-field v-model="editedItem.taxid" type="text" label="Tax Identification"></v-text-field>
                  </v-flex> -->
                  <v-flex xs6 sm6 md6>
                    <v-text-field v-model="editedItem.discount" type="number" label="Discount"></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm6 md6>
                    <v-text-field v-model="editedItem.vat" type="number" label="VAT"></v-text-field>
                  </v-flex>
                  <v-flex x6 sm6 md6>
                    <v-layout wrap class="fontLao">
                      <v-flex xs6 sm6 md6>
                        <v-text-field v-model="editedItem.debitday" type="number" label="ຈຳນວນເຄດິດ"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs6 sm6 md6>
                      <v-autocomplete
                        :items="sellers"
                        v-model="editedItem.seid"
                        item-value="id"
                        item-text="name"
                        flat
                        hide-no-data
                        hide-details
                        label="ຜູ້ຂາຍ"
                        @change="initbranches()"
                      ></v-autocomplete>
                </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer >
              <v-btn color="blue darken-1" flat @click.native="close" class="fontLao">ຍົກເລີກ</v-btn>
              <v-btn color="blue darken-1" flat @click.native="save" class="fontLao">ບັນທືກ</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table :headers="headers" :pagination.sync="pagination" :items="mydata" :search="search" :rows-per-page-items=[10,20,50,100,500] class="elevation-1 fixtable">
        <template slot="items" slot-scope="props">
          <td>{{ props.item.date.seconds }}</td>
          <td>{{ props.item.order }}</td>
          <!-- <td>{{ props.item.orderdate }}</td> -->
          <td>{{ props.item.invoiceno }}</td>
          <td>{{ props.item.invoicedate }}</td>
          <td>{{ _P(props.item.amount) }}</td>
          <td>{{ props.item.cname }}</td>
          <td>{{ props.item.sellname }}</td>

          <!-- <td>{{ props.item.taxid }}</td> -->
          <!-- <td>{{ props.item.discount }}</td> -->
          <!-- <td>{{ props.item.vat }}</td> -->
          <td v-if="props.item.debitstt">ເຄດິດ ({{props.item.debitday}}ວັນ) </td>
          <td v-if="!props.item.debitstt">ຈ່າຍສົດ</td>
          <td class="text-xs-center px-0">

            <v-icon small @click="paystt(props.item)" >attach_money</v-icon>
            <v-icon small @click="gotopageStockOut(props.item)" >arrow_downward</v-icon>
            <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
            <v-icon small @click="deleteItem(props.item)" > delete </v-icon>
          </td>
        </template>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">ກົດເລີ່ມໃໝ່</v-btn>
        </template>
      </v-data-table>
    </div>
  </v-app>
</template>
<script>
import db from '@/firebase/init'
import moment from 'moment'
// moment(new Date()).format('YYYY-MM-DD')
  export default {
    name:'export',
    data: () => ({
      dialog: false,
      search: '',
      customer: [],
      branches: [],
      sellers:[],
      branch:'',
      pagination : {'sortBy': 'date', 'descending': true, 'rowsPerPage': -1},
      headers: [
        {text: 'ID', value: 'date' ,align: 'left'},
        {text: 'Order#', value: 'order' ,align: 'left'},
        {text: 'Invoice No', value: 'invoiceno' ,align: 'left'},
        {text: 'Invoice Date', value: 'invoicedate' ,align: 'left'},
        {text: 'Amount', value: 'amount'  ,align: 'left'},
        {text: 'Customer', value: 'cname'  ,align: 'left'},
        // {text: 'Tax ID', value: 'taxid' ,align: 'left'},
        // {text: 'Discount', value: 'discount' ,align: 'left'},
        // {text: 'VAT', value: 'vat' ,align: 'left'},
        {text: 'ຜູ້ຂາຍ', value: 'sellname' ,align: 'left'},
        {text: 'ສະຖານະ', value: 'debitstt' ,align: 'left'},
        {text: 'ການເຄື່ອນໄຫວ', value: 'action', sortable: false,align: 'center'}
      ],
      mydata: [],
      editedIndex: -1,
      editedItem: {
        order: null,
        orderdate: null,
        invoiceno: null,
        invoicedate: null,
        cusid: null,
        branchname:null,
        branchtel:null,
        // taxid: null,
        discount: 0,
        vat: 0,
        debitday:0,
        debitstt:false,
        date: new Date(),
        stt:1
      },
      defaultItem: {
        order: null,
        orderdate: null,
        invoiceno: null,
        invoicedate: null,
        cusid: null,
        branchname:null,
        branchtel:null,
        // taxid: null,
        discount: 0,
        vat: 0,
        debitday:0,
        debitstt:false,
        date: new Date(),
        stt:1,
        amount:0
      }
    }),
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'ເພີ່ມ' : 'ແກ້ໄຂ'
      }
    },
    watch: {
      dialog (val) {
        if (val){
          if (this.editedIndex === -1){

            setTimeout(() => {
              this.getinvoce()
            //  this.editedItem.invoicedate =  new Date()
            //  this.editedItem.orderdate =  new Date()
              //this.editedItem.order =this.getinvoce()// moment(Date.now()).valueOf()
            },250)
            // setTimeout(() => {
            //   this.editedItem.invoiceno = this.getinvoce()// moment(Date.now()).valueOf()
            // },300)
          }
        }
        val || this.close()
      },
      editedItem(val){
        //this.initbranches(v)
      }
    },
    created () {
      this.initialize()
      this.initcustomer()
      this.initseller()
    },
    methods: {
    _P (value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    initialize () {
      let tdata = []

      let ref = db.collection('export').where("stt","==",1).orderBy("date", "desc").limit(500).get()
      .then(async snapshot => {
              var tcus =[]
              await db.collection('customer').where("stt","==",1).get().then(snapshotc => {
                var c =[]
             snapshotc.forEach(d=>{
               c[d.id]=d.data()
             })
             tcus = c
            }).catch(function(error) {
              console.log("Error getting document:", error);
            })

        snapshot.forEach(async doc => {
          let tmpdata =doc.data()
          tmpdata.id =doc.id
          // const tmporderdate = doc.get('orderdate')
          // const orderdate = moment(tmporderdate.toDate()).format('YYYY-MM-DD')
          const tmpinvoicedate = doc.get('invoicedate')
          const invoicedate = moment(tmpinvoicedate.toDate()).format('YYYY-MM-DD')
         // tmpdata.date = moment(doc.get('date').toDate()).format('YYYY-MM-DD')
          // tmpdata.orderdate = orderdate
          tmpdata.invoicedate = invoicedate

          if (doc.data().cusid) {
               tmpdata.cname = tcus[doc.data().cusid].name ;
          }
          if (doc.data().seid) {
            var sss=this.sellers.find(o=>o.id === doc.data().seid)
                if(sss){
                      tmpdata.sellname = sss.name
                }
          }
          tdata.push(tmpdata)
        })
        this.mydata=tdata
      })
      .catch(err => {
        console.log('Error getting documents', err)
      })
      // db.collection('export').where("stt","==",1).get()
      // .then(snapshot => {
      //   snapshot.forEach(async doc => {
      //     const date = doc.data().orderdate
      //     const ref = await db.collection('export').doc(doc.id)
      //     await db.collection('stock').where("stt","==",1).where('exportref','==',ref).get().then(snapshots => {
      //       for (let index = 0; index < snapshots.docs.length; index++) {
      //         const ref = snapshots.docs[index].ref;
      //         ref.set({ stockdate: date }, { merge: true })
      //       }
      //     })
      //   })
      // })
      // db.collection('export').where("stt","==",0).get()
      // .then(snapshot => {
      //   snapshot.forEach(async doc => {
      //     const ref = await db.collection('export').doc(doc.id)
      //     await db.collection('stock').where("stt","==",1).where('exportref','==',ref).get().then(snapshots => {
      //       for (let index = 0; index < snapshots.docs.length; index++) {
      //         const ref = snapshots.docs[index].ref;
      //         ref.update({stt:0})
      //       }
      //     })
      //   })
      // })
    },
    initcustomer () {
      let cdata = []
      db.collection('customer').where("stt","==",1).get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let tmpdata = doc.data()
          tmpdata.id = doc.id
          cdata.push(tmpdata)
        })
        this.customer = cdata
      })
      .catch(err => {
        console.log('Error getting documents', err)
      })
    },
    initseller () {
      let data = []
      db.collection('seller').where("stt","==",1).get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let tmpdata = doc.data()
          tmpdata.id = doc.id
          data.push(tmpdata)
        })
        this.sellers = data
      })
      .catch(err => {
        console.log('Error getting documents', err)
      })
    },
    initbranches() {
      //console.log('cus',cus)
      this.branches=null;
      this.branches=[];
      let data = []
      let ref = db.collection('customer').doc(this.editedItem.cusid).collection('branches').where("stt","==",1).get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let tmpdata = doc.data()
          tmpdata.id = doc.id,
          tmpdata.branchref = ref
          data.push(tmpdata)
        })
        this.branches = data
      })
      .catch(err => {
        console.log('Error getting documents', err)
      })
    },
    getbranches() {
         let data = []
      console.log(this.editedItem.cusid,this.editedItem.branch)
      let ref = db.collection('customer').doc(this.editedItem.cusid).collection('branches').doc(this.editedItem.branch).get()
      ref.then(doc => {
       console.log( doc.data())
       this.editedItem.branchname = doc.data().branch
       if(doc.data().tel){
        this.editedItem.branchtel = doc.data().tel
       }
      })
      .catch(err => {
        console.log('Error getting documents', err)
      })
    },
    getinvoce() {
         let data = []
      let ref = db.collection('config').doc('invoice').get()
      ref.then(doc => {
       var no =String(Number(doc.data().startno)+1);
          var z =""
        for( var i=no.length;i<6;i++){z =z +"0" }
          this.editedItem.invoiceno=z + doc.data().startno
         // this.editedItem.order= z + doc.data().startno
      })
      .catch(err => {
        console.log('Error getting documents', err)
      })
    },
    editItem (item) {
      this.editedIndex = this.mydata.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
      console.log(item)
    },
    deleteItem (item) {
      const index = this.mydata.indexOf(item)
      if ( confirm('Are you sure you want to delete this item ('+item.cname+' )?')) {
        db.collection('export').doc(item.id).update({stt:0})
        const ref = db.collection('export').doc(item.id)
          db.collection('stock').where("stt","==",1).where('exportref','==',ref).get().then(snapshots => {
            for (let index = 0; index < snapshots.docs.length; index++) {
              const ref = snapshots.docs[index].ref;
              ref.update({stt:0})
            }
          })
        this.mydata.splice(index, 1)
      }
    },
    paystt (item) {
      const index = this.mydata.indexOf(item)
      if ( confirm('ປ່ຽສະຖານະ ເປັນຈ່າຍ ແທ້ບໍ່ ('+item.order+' '+item.cname+' )?')) {
        db.collection('export').doc(item.id).update({debitstt:false})
       // this.mydata.splice(index, 1)
        this.initialize()
      this.close()
      }
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
     // console.log(this.editedItem)
     // return
      if (this.editedIndex > -1) {
        // Object.assign(this.mydata[this.editedIndex], this.editedItem)
        let id=this.editedItem.id;
        delete this.editedItem.id;
        delete this.editedItem.date;
        // this.editedItem.taxid =parseInt(this.editedItem.taxid)
        this.editedItem.discount =parseInt(this.editedItem.discount)
        this.editedItem.vat =parseInt(this.editedItem.vat)
        this.editedItem.orderdate = new Date(this.editedItem.orderdate)
        this.editedItem.invoicedate = new Date(this.editedItem.invoicedate)
        this.editedItem.debitday =parseInt(this.editedItem.debitday)
        if(this.editedItem.debitday>0)
        this.editedItem.debitstt = true
        else this.editedItem.debitstt = false
        db.collection('export').doc(id).update(this.editedItem)
        const date = this.editedItem.orderdate
        const ref = db.collection('export').doc(id)
        db.collection('stock').where("stt","==",1).where('exportref','==',ref).get().then(snapshots => {
          for (let index = 0; index < snapshots.docs.length; index++) {
            const ref = snapshots.docs[index].ref;
            ref.set({ stockdate: date }, { merge: true })
          }
        })
      } else {
        this.editedItem.debitday =parseInt(this.editedItem.debitday)
        if(this.editedItem.debitday>0)
        this.editedItem.debitstt = true
        else this.editedItem.debitstt = false
        this.editedItem.orderdate = new Date(this.editedItem.orderdate)
        this.editedItem.invoicedate = new Date(this.editedItem.invoicedate)
                db.collection('config').doc('invoice').get().then(doc => {
                var no =String(Number(doc.data().startno)+1);
                console.log(no)
                    db.collection('config').doc('invoice').set({startno:no})
                var z =""
              for( var i=no.length;i<6;i++){z =z +"0" }
                this.editedItem.invoiceno=z + doc.data().startno
              //  this.editedItem.order= z + doc.data().startno
            })
            .catch(err => {
              console.log('Error getting documents', err)
            })
        let ref = db.collection('export').add(this.editedItem).then(

        )

      }
      this.initialize()
      this.close()
    },
    gotopageStockOut (item) {
      this.$router.push({ name: 'StockOut', params: { id:item.id  }})
    },
    gotopageStockOut (item) {
      this.$router.push({ name: 'StockOut', params: { id:item.id  }})
    }

  }
}
</script>

<style>
.fontLao{
font-family: phetsarath ot !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Export.vue